(ns manage.adset-decision-tree-page.tagging-and-trackers.macro-input
  (:require [common.trie :as trie]
            [manage.adset.hooks :as adset.h]
            [manage.slate-editor.macro-input :as macro-input]
            [uix.core :as uix :refer [defui defhook $]]
            [uix.re-frame :refer [use-subscribe]]))

;; Those are the macros available specifically for "meta" adsets.
(def ^:private meta-tagging-hints
  ["ad.id"
   "ad.name"
   "adset.id"
   "adset.name"
   "campaign.id"
   "campaign.name"
   "placement"
   "site_source_name"])

(defhook use-macro-set []
  (let [{:keys [taggingHints]} (use-subscribe [:config])
        channel (adset.h/use-channel)]
    (-> (if (= channel "meta")
          meta-tagging-hints
          taggingHints)
        set)))

(defui macro-input [props]
  (let [macro-set (use-macro-set)
        macro-trie (uix/use-memo (fn []
                                   (trie/build-trie macro-set #{}))
                                 [macro-set])]
    ($ macro-input/macro-input (assoc props
                                      :get-auto-complete-options (fn [macro-content-text]
                                                                   (trie/prefix-matches macro-content-text macro-trie))
                                      :is-macro-valid? (fn [macro-content-text]
                                                         (contains? macro-set macro-content-text))
                                      :get-popper-props (fn [{:keys [anchorEl]}]
                                                          ;; We need to enable portal to make sure the options list
                                                          ;; pops out of the modal.
                                                          {:disablePortal false
                                                           :sx #js {:zIndex 1300
                                                                    :width (some-> anchorEl .-clientWidth)}})))))
